import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { useIsPaidPortal } from '../v2/hooks/inventory/useProductInventory';
export const useAddOnsPage = options => {
  var _options$loading;
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const {
    isPaidPortal
  } = useIsPaidPortal();
  const isLoading = (_options$loading = options === null || options === void 0 ? void 0 : options.loading) !== null && _options$loading !== void 0 ? _options$loading : false;
  const showAddonsPage = !isLoading && isAppAuth && isPaidPortal;
  return {
    showAddonsPage
  };
};